NtechApp.ChatMembers = function($view, chatMessagesForm) {
    var me = this;

    this._$view = null;

    this._click = null;
    this._chatMessagesForm = null;

    this._$heading = null;

    this._$chatMembersPopup = null;
    this._$chatMembersPopupContent = null;
    this._chatMembersList = null;

    this._construct = function() {
        me._$view = $view;

        me._click = new NtechApp.TouchClickEvent();
        me._chatMessagesForm = chatMessagesForm;

        me._$heading = me._$view.find("[data-selectedChatName]");

        me._$chatMembersPopup = $("<div/>").appendTo($("body"));
        me._$chatMembersPopup.addClass("defaultSelectListPopup");

        var $list = $("<div/>").addClass("list");
        var $scrollableList = $("<div/>").addClass("scrollableList");

        $list.append($scrollableList);
        me._$chatMembersPopup.append($list);

        me._$chatMembersPopupContent = $scrollableList;

        NtechApp.lockScroll(me._$chatMembersPopupContent);

        me._chatMembersList = new NtechApp.SelectList(
            me._$chatMembersPopup,
            me._$view.closest(".rightSide").find("[data-selectedChatName]"),
            null,
            15
        );

        me._bindEvents();
    }

    this._bindEvents = function() {
        $(window).on(NtechApp.ChatMembers.EVENT_WINDOW_RESIZE, function() {
            me._renderChatName.call(me);
        });

        me._click.listen(me._$heading, function() {
            me._chatMembersList.on();
        });
    }

    this._unbindEvents = function() {
        ;
    }

    this.destruct = function() {
        me._unbindEvents();
    }

    this._construct();
    return this;
};

NtechApp.ChatMembers.EVENT_WINDOW_RESIZE = "resize.NtechApp.ChatMembers";

NtechApp.proto(NtechApp.ChatMembers, {
    updateLabel: function(chatName, shortChatName, chatMembers) {
        var me = this;

        me._$heading.attr("data-chatName", chatName);
        me._$heading.attr("data-shortChatName", shortChatName);

        me._$chatMembersPopupContent.find(".link").remove();
        for(var i = 0; i < chatMembers.length; i++) {
            var $item = $("<div/>").addClass("link");
            $item.text(chatMembers[i]);

            me._$chatMembersPopupContent.append($item);
        }

        me._renderChatName();
    },

    _renderChatName: function() {
        if(NtechApp.isMobile599())
            this._$heading.text(this._$heading.attr("data-shortChatName"));
        else
            this._$heading.text(this._$heading.attr("data-chatName"));
    }
});